import {Box, Typography} from '@mui/material';
import {BackspaceTwoTone, GroupTwoTone} from '@mui/icons-material';
import React from 'react';

const StatsSpigot = ({ stats }) => {
    return (
        <Box className='flow-sidebar__body-hihlighter' display='flex' style={{padding: '5px 0px'}}>
            <Box sx={{width: '100%'}} display='flex' flexDirection='column'>
                <Box display='flex' flexGrow={1} alignItems='center' mb={2}>
                    <GroupTwoTone style={{marginRight: 10}}/>
                    <Typography component='div' variant='subtitle1'>Total Travellers: <span style={{fontWeight: 400}}>{stats.journeyed}</span></Typography>
                </Box>
                <Box display='flex' flexGrow={1} alignItems='center' mb={2}>
                    <BackspaceTwoTone style={{marginRight: 10}}/>
                    <Typography component='div' variant='subtitle1'>Completed: <span style={{fontWeight: 400}}>{stats.completed}</span></Typography>
                </Box>
                {Object.entries(stats.completed_by_exit_result || {}).map(([key, value]) => {
                    const label = key === 'processed' ? 'Continue Journey' : 
                                  key === 'step_exit' ? 'Exit Journey' : key;
                    return (
                        <Box key={key} display='flex' flexGrow={1} alignItems='center' mb={2}>
                            <Typography component='div' variant='subtitle1'>
                                {label}: <span style={{fontWeight: 400}}>{value}</span>
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default StatsSpigot; 